{
  "familyId": "REK-GEMENGD-BASIS",
  "questions": [
    {
      "id": "REK-GEMENGD-BASIS-001",
      "familyId": "REK-GEMENGD-BASIS",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "gemengd",
      "subSkill": "gemengd_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Welke bewerking gebruik je? Een bakker bakt 8 broden per uur. Hij werkt 6 uur. Hoeveel broden bakt hij?",
      "options": ["8 × 6 = 48", "8 + 6 = 14", "8 − 6 = 2", "8 ÷ 6 = 1,3..."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Welke bewerking? — Herhaald optellen = keer",
            "content": "8 broden per uur, 6 uur lang. Dat is 8 + 8 + 8 + 8 + 8 + 8 = herhaald optellen. Herhaald optellen = vermenigvuldigen: 8 × 6 = 48. Signaalwoord: 'per' wijst vaak op vermenigvuldigen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_bewerking_herkennen_keer",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "8 broden per uur, 6 uur lang = 8 × 6 = 48 broden. Het signaalwoord 'per' wijst op vermenigvuldigen: een vast aantal dat zich herhaalt.",
        "solutionSteps": [
          "Lees: 8 broden per uur, 6 uur",
          "Herken signaalwoord 'per' → vermenigvuldigen",
          "Bewerking: 8 × 6 = 48 broden"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Per uur' wijst op vermenigvuldigen: 8 × 6 = 48 broden.",
          "1": "Optellen (8 + 6 = 14) klopt niet. De bakker bakt niet 8 broden EN 6 broden, maar 8 broden PER uur gedurende 6 uur. Dat is vermenigvuldigen.",
          "2": "Aftrekken (8 − 6 = 2) klopt niet. Er gaat niets af — de bakker bakt broden, hij verliest ze niet.",
          "3": "Delen (8 ÷ 6) klopt niet. Je deelt niet 8 broden over 6 uur — je bakt 8 broden IN elk uur. Dat is vermenigvuldigen."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.operation-confused", "label": "Verwart × met +", "optionIndex": 1 },
          { "id": "rek.operation-confused", "label": "Verwart × met −", "optionIndex": 2 },
          { "id": "rek.operation-confused", "label": "Verwart × met ÷", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-GEMENGD-BASIS-002",
      "familyId": "REK-GEMENGD-BASIS",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "gemengd",
      "subSkill": "gemengd_bewerkingen",
      "questionType": "fill_in",
      "question": "Reken uit: 156 + 87 − 43",
      "options": [],
      "correctAnswer": "200",
      "data": {
        "acceptedAnswers": ["200"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Van links naar rechts",
            "content": "Bij optellen en aftrekken reken je van links naar rechts. Eerst: 156 + 87 = 243. Dan: 243 − 43 = 200. Tip: 243 − 43 is makkelijk — de tientallen en eenheden zijn gelijk!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_plus_min_combinatie",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Van links naar rechts: 156 + 87 = 243, dan 243 − 43 = 200. Tip: als de eenheden en tientallen gelijk zijn (243 − 43), is het aftrekken extra makkelijk!",
        "solutionSteps": [
          "Stap 1: 156 + 87 = 243",
          "Stap 2: 243 − 43 = 200"
        ]
      }
    },
    {
      "id": "REK-GEMENGD-BASIS-003",
      "familyId": "REK-GEMENGD-BASIS",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "gemengd",
      "subSkill": "gemengd_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Welke bewerking gebruik je? 96 leerlingen worden verdeeld over 8 gelijke groepen. Hoeveel leerlingen zitten er in elke groep?",
      "options": ["96 ÷ 8 = 12", "96 − 8 = 88", "96 × 8 = 768", "96 + 8 = 104"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen = delen",
            "content": "96 leerlingen verdelen over 8 groepen = 96 ÷ 8. Signaalwoord: 'verdelen over' wijst op delen. 96 ÷ 8 = 12 leerlingen per groep.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_bewerking_herkennen_delen",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Verdelen over gelijke groepen' = delen. 96 ÷ 8 = 12 leerlingen per groep. Signaalwoorden voor delen: 'verdelen', 'per', 'hoeveel in elke', 'eerlijk verdelen'.",
        "solutionSteps": [
          "Herken signaalwoord: 'verdelen over' → delen",
          "Bewerking: 96 ÷ 8",
          "Antwoord: 96 ÷ 8 = 12 leerlingen"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Verdelen over' = delen: 96 ÷ 8 = 12 leerlingen per groep.",
          "1": "Aftrekken (96 − 8 = 88) klopt niet. Je haalt niet 8 leerlingen weg — je verdeelt ze in groepen.",
          "2": "Vermenigvuldigen (96 × 8 = 768) klopt niet. Je hebt 96 leerlingen, niet 96 groepen van 8.",
          "3": "Optellen (96 + 8 = 104) klopt niet. Er komen geen leerlingen bij — je verdeelt de bestaande 96."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "rek.operation-confused", "label": "Verwart ÷ met −", "optionIndex": 1 },
          { "id": "rek.operation-confused", "label": "Verwart ÷ met ×", "optionIndex": 2 },
          { "id": "rek.operation-confused", "label": "Verwart ÷ met +", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-GEMENGD-BASIS-004",
      "familyId": "REK-GEMENGD-BASIS",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "gemengd",
      "subSkill": "gemengd_bewerkingen",
      "questionType": "fill_in",
      "question": "Reken uit: 7 × 9 + 37",
      "options": [],
      "correctAnswer": "100",
      "data": {
        "acceptedAnswers": ["100"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde: × en ÷ gaan vóór + en −",
            "content": "Bij gemengde bewerkingen reken je eerst × en ÷, dan + en −. Eerst: 7 × 9 = 63. Dan: 63 + 37 = 100. Je mag NIET eerst 9 + 37 = 46 doen en dan 7 × 46 = 322!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_volgorde_keer_plus",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Volgorde: × gaat vóór +. Eerst 7 × 9 = 63, dan 63 + 37 = 100. Onthoud: Meneer Van Dansen Wacht Op Antwoord — × en ÷ komen vóór + en −.",
        "solutionSteps": [
          "Volgorde: × gaat vóór +",
          "Eerst: 7 × 9 = 63",
          "Dan: 63 + 37 = 100"
        ]
      }
    },
    {
      "id": "REK-GEMENGD-BASIS-005",
      "familyId": "REK-GEMENGD-BASIS",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "gemengd",
      "subSkill": "gemengd_bewerkingen",
      "questionType": "multiple_choice",
      "question": "Een winkelier heeft 5 dozen met elk 24 flessen sap. Ze verkoopt 38 flessen. Hoeveel flessen heeft ze nog?",
      "options": ["82 flessen", "120 flessen", "158 flessen", "62 flessen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee bewerkingen: eerst ×, dan −",
            "content": "Stap 1: Hoeveel flessen in totaal? 5 × 24 = 120. Stap 2: Hoeveel over na verkoop? 120 − 38 = 82. Tip: herken de twee bewerkingen — 'dozen met elk' = ×, 'verkoopt' = −.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_context_keer_min",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Totaal: 5 × 24 = 120 flessen. Verkocht: 120 − 38 = 82 flessen over. Twee bewerkingen: 'dozen met elk' = vermenigvuldigen, 'verkoopt' = aftrekken.",
        "solutionSteps": [
          "Stap 1: 5 dozen × 24 flessen = 120 flessen",
          "Stap 2: 120 − 38 verkocht = 82 flessen over"
        ],
        "distractorExplanations": {
          "0": "Goed! 5 × 24 = 120, dan 120 − 38 = 82 flessen over.",
          "1": "Je berekende het totaal (5 × 24 = 120) maar vergat de 38 verkochte flessen af te trekken. 120 − 38 = 82.",
          "2": "Je dacht waarschijnlijk 5 × 24 = 120, dan 120 + 38 = 158. Maar flessen worden VERKOCHT — dat is aftrekken, niet optellen.",
          "3": "Je dacht waarschijnlijk 5 × 24 = 120, dan 120 − 58 = 62. Maar er zijn 38 flessen verkocht, niet 58. 120 − 38 = 82."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-step-forgotten", "label": "Vergeet aftrekstap: geeft totaal i.p.v. rest", "optionIndex": 1 },
          { "id": "rek.context-direction-wrong", "label": "Telt op i.p.v. aftrekt", "optionIndex": 2 },
          { "id": "rek.context-wrong-data", "label": "Gebruikt 58 i.p.v. 38 verkocht", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-GEMENGD-BASIS-006",
      "familyId": "REK-GEMENGD-BASIS",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "gemengd",
      "subSkill": "gemengd_bewerkingen",
      "questionType": "error_spotting",
      "question": "Een leerling heeft deze som uitgerekend. Zoek de fout en verbeter het antwoord.",
      "data": {
        "text": "5 × 8 + 12 = 5 × 20 = 100",
        "errors": [
          {
            "word": "100",
            "position": 8,
            "correction": "52",
            "explanation": "De leerling rekende eerst 8 + 12 = 20, maar × gaat vóór +. Goed: eerst 5 × 8 = 40, dan 40 + 12 = 52."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde van bewerkingen",
            "content": "Bij gemengde bewerkingen reken je eerst × en ÷, dan + en −.\n\n5 × 8 + 12:\nStap 1: 5 × 8 = 40 (× gaat eerst)\nStap 2: 40 + 12 = 52\n\nDe leerling deed eerst 8 + 12 = 20. Dat mag niet — × gaat vóór +.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_volgorde_fout_herkennen",
      "variantIndex": 6,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De leerling rekende eerst 8 + 12 = 20, en dan 5 × 20 = 100. Maar × gaat vóór +! Goed: eerst 5 × 8 = 40, dan 40 + 12 = 52. Onthoud: Meneer Van Dalen Wacht Op Antwoord — × en ÷ komen vóór + en −.",
        "solutionSteps": [
          "Lees de berekening: 5 × 8 + 12 = 5 × 20 = 100",
          "Herken de fout: de leerling deed eerst 8 + 12 = 20",
          "Regel: × gaat vóór +",
          "Goed: 5 × 8 = 40, dan 40 + 12 = 52"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.left-to-right", "label": "Rekent van links naar rechts zonder voorrang ×/÷" }
        ]
      }
    },
    {
      "id": "REK-GEMENGD-BASIS-007",
      "familyId": "REK-GEMENGD-BASIS",
      "module": "Basisrekenen",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "gemengd",
      "subSkill": "gemengd_bewerkingen",
      "questionType": "true_false_series",
      "question": "Beoordeel elke bewering: waar of onwaar?",
      "data": {
        "statements": [
          { "text": "12 + 3 × 4 = 24", "isTrue": true },
          { "text": "Bij 6 + 2 × 5 reken je eerst 6 + 2 = 8 uit", "isTrue": false },
          { "text": "'Verdelen over gelijke groepen' betekent: delen", "isTrue": true },
          { "text": "100 − 7 × 9 = 37", "isTrue": true },
          { "text": "× en ÷ reken je altijd als laatste uit", "isTrue": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde en bewerkingen",
            "content": "Regels:\n1. × en ÷ reken je EERST uit, dan + en −\n2. 'Verdelen over' = delen (÷)\n3. 'Per' of 'elk' = vermenigvuldigen (×)\n\nVoorbeeld: 12 + 3 × 4 → eerst 3 × 4 = 12, dan 12 + 12 = 24 ✓",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_regels_beoordelen",
      "variantIndex": 7,
      "citoDifficulty": 0.43,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "1) 12 + 3 × 4: eerst 3 × 4 = 12, dan 12 + 12 = 24 → WAAR. 2) Bij 6 + 2 × 5 reken je eerst × uit: 2 × 5 = 10, dan 6 + 10 = 16. Niet eerst 6 + 2 → ONWAAR. 3) 'Verdelen over gelijke groepen' = delen → WAAR. 4) 100 − 7 × 9: eerst 7 × 9 = 63, dan 100 − 63 = 37 → WAAR. 5) × en ÷ reken je EERST uit, niet als laatste → ONWAAR.",
        "solutionSteps": [
          "12 + 3 × 4 = 12 + 12 = 24 → waar",
          "6 + 2 × 5: eerst 2 × 5 = 10, niet 6 + 2 = 8 → onwaar",
          "'Verdelen over' = delen → waar",
          "100 − 7 × 9 = 100 − 63 = 37 → waar",
          "× en ÷ gaan EERST, niet als laatste → onwaar"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.left-to-right", "label": "Denkt dat + en − vóór × en ÷ gaan" },
          { "id": "rek.brackets-ignored", "label": "Kent de voorrangsregel niet" }
        ]
      }
    }
  ]
}